import Link from "next/link";

import Image from "@/components/Image";

import styles from "@/styles/Home.module.css";

function AlbumReview({ cover, artist, title, url }) {
  return (
    <Link href={url}>

      <Image
        src={cover}
        width={500}
        height={500}
        alt={`${title} by ${artist}`}
      />
      <p>
        <b>{artist}</b>
        <br />
        <i>{title}</i>
      </p>

    </Link>
  );
}

function AlbumReviewGrid({ contentComponent, reviews }) {
  const PageComponent = contentComponent || AlbumReview;
  return (
    <div className="row">
      {reviews &&
        reviews.map((review, i) => {
          review = review.node ? review.node : review;
          return (
            <div className={`${styles.album} col-6 col-md-3`} key={review.id}>
              <PageComponent {...review} i={i} />
            </div>
          );
        })}
    </div>
  );
}

export default AlbumReviewGrid;
